import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import UserContext from "./UserContext";

const useUserContext = () => useDefinedContext(UserContext, "UserContext");

export default useUserContext;
